import Button from "components/common/Button";
import CustomTable from "components/common/CustomTable";
import SynthTooltip from "components/common/SynthTooltip";
import VendorAvatar from "components/common/VendorAvatar";
import { formatMoney, getCurrencyFromCurrencyCode } from "helpers";
import { useAppDispatch, useAppSelector } from "hooks/storeHooks";
import React, { useEffect, useState } from "react";
import { inventoryActions } from "redux/Ldb/actions";

type ArchiveProductProps = {
    resultMessage: {
        message: string;
        products: Record<string, any>;
        success: boolean;
    };
    toolName: string;
};

const ArchiveProduct = ({ resultMessage, toolName }: ArchiveProductProps) => {
    const dispatch = useAppDispatch();
    const [selectedId, setSelectedId] = useState<string>("");

    const { settingArchiveStatus, setArchiveStatusSuccess } = useAppSelector(
        (state) => state.inventory
    );

    const handleArchiveUnarchiveProduct = (inventoryId: string, status: boolean) => {
        setSelectedId(inventoryId);
        const body = {
            inventories: [
                {
                    inventoryId: inventoryId,
                    archived: status,
                },
            ],
        };
        dispatch(inventoryActions.setArchiveStatus(body));
    };

    useEffect(() => {
        if (setArchiveStatusSuccess) {
            setSelectedId("");
            dispatch(inventoryActions.resetSetArchiveStatusSuccess());
        }
    }, [setArchiveStatusSuccess, dispatch]);

    const tableHeader = [
        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">
                        Product name
                    </span>
                </div>
            ),
            widthClass: "w-[280px] !border-r-none",
        },
        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">SKU No. </span>
                </div>
            ),
            widthClass: "w-[109px] !border-r-none",
        },
        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">Categories</span>
                </div>
            ),
            widthClass: "w-[134px] !border-r-none",
        },
        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">Status</span>
                </div>
            ),
            widthClass: "w-[134px] !border-r-none",
        },
        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">
                        Curr. stock level
                    </span>
                </div>
            ),
            widthClass: "w-[122px] !border-r-none",
        },
        // {
        //     title: (
        //         <div className="flex space-x-1.5 items-center">
        //             <span className="text-xs font-rocGroteskMedium text-slate-700">Action</span>
        //         </div>
        //     ),
        //     widthClass: "w-[111px] !border-r-none",
        // },
    ];
    const tableBody = resultMessage?.products?.map((item, idx) => {
        return [
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-g-75  py-2`}
                    >
                        <div className="flex items-center space-x-3">
                            <div className="flex items-center space-x-3">
                                {item?.product?.productImageDetails?.productImages?.[0] ? (
                                    <VendorAvatar
                                        imageSrc={
                                            item?.product?.productImageDetails?.productAvatar ||
                                            item?.product?.productImageDetails?.productImages?.[0]
                                        }
                                        size={32}
                                        name={item?.product?.productName}
                                        containerClassname="!rounded-md"
                                    />
                                ) : (
                                    <div className="w-8 h-8 rounded shrink-0 flex items-center justify-center bg-slate-200 ">
                                        <i className="ri-box-2-fill text-lg text-slate-500"></i>
                                    </div>
                                )}
                                <p className="">{item?.product?.productName || ""}</p>
                            </div>
                        </div>
                    </div>
                ),
            },
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-g-75  py-2 break-all`}
                    >
                        <div>
                            <p className="text-slate-500 ">{item?.product?.sku || "N/A"}</p>
                        </div>
                    </div>
                ),
            },
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-g-75  py-2`}
                    >
                        <div>
                            <p className="text-slate-500 ">
                                {item?.product?.inventoryCategory || "N/A"}
                            </p>
                        </div>
                    </div>
                ),
            },
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-g-75  py-2`}
                    >
                        <div>
                            {item?.archived ? (
                                <p className="text-g-75 text-sm bg-slate-200 px-2 py-[2px] rounded-2xl">
                                    Archived
                                </p>
                            ) : (
                                <p className="text-white text-sm bg-[#0AAD0A] px-2 py-[2px] rounded-2xl ">
                                    Unarchive
                                </p>
                            )}
                        </div>
                    </div>
                ),
            },
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-g-75  py-2`}
                    >
                        <p className="">
                            {!item?.products?.productStockDetails?.stockLevel
                                ? `${formatMoney()?.format(
                                      item?.products?.productStockDetails?.stockLevel ?? 0
                                  )} ${
                                      item?.products?.productStockDetails?.unitOfMeasurement || ""
                                  }`
                                : "N/A"}
                        </p>
                    </div>
                ),
            },
            // {
            //     content: (
            //         <div
            //             key={idx}
            //             className={`!font-rocGroteskMedium border-slate-100 text-sm text-g-75  py-2`}
            //         >
            //             {item?.archived ? (
            //                 <Button
            //                     onClick={() =>
            //                         handleArchiveUnarchiveProduct(item?.product?._id, false)
            //                     }
            //                     btnClassname="text-xs text-g-75 !bg-[#E2E8F0] px-4 py-1.5"
            //                     btnText="Unarchive"
            //                     isLoading={
            //                         settingArchiveStatus && item?.product?._id === selectedId
            //                     }
            //                 />
            //             ) : (
            //                 <Button
            //                     onClick={() =>
            //                         handleArchiveUnarchiveProduct(item?.product?._id, true)
            //                     }
            //                     btnClassname="text-xs text-g-75 !bg-[#E2E8F0] px-4 py-1.5"
            //                     btnText="Restore"
            //                     isLoading={
            //                         settingArchiveStatus && item?.product?._id === selectedId
            //                     }
            //                 />
            //             )}
            //         </div>
            //     ),
            //     widthClass: " !border-b",
            // },
        ];
    });
    return (
        <>
            {resultMessage?.success && resultMessage?.products?.length > 0 && (
                <div>
                    <CustomTable
                        tableBody={tableBody}
                        tableHeader={tableHeader}
                        isCellBordered={true}
                        stickyHeader={true}
                        headerContainerClass="!bg-slate-50 "
                        headerItemClass="font-rocGroteskMedium "
                        tableClass="mb-4"
                        isScrollable={true}
                        scrollWithin={true}
                        renderEmptyTable={() => null}
                    />
                </div>
            )}
        </>
    );
};

export default ArchiveProduct;
